export const mutations = {
  TUTORIAL_RESET: "TUTORIAL_RESET",
  TUTORIAL_FETCH_PLAYLIST: "TUTORIAL_FETCH_PLAYLIST",
  TUTORIAL_FETCH_PLAYLISTS: "TUTORIAL_FETCH_PLAYLISTS",
  TUTORIAL_SET_TOPIC: "TUTORIAL_SET_TOPIC"
}

export const actions = {
  TUTORIAL_GET_PLAYLIST: "tutorialGetPlaylist",
  TUTORIAL_GET_PLAYLISTS: "tutorialGetPlaylists",
  SECTION_GET: "sectionGet",
  FAQS_OPEN_MODAL: "openFaqsModal",
  FAQS_CLOSE_MODAL: "closeFaqsModal",
  STARTED_GUIDE_OPEN: "openStartedGuide",
  STARTED_GUIDE_CLOSE: "closeStartedGuide"
}
